const { generateEntryUrl } = require('./generate-url-functions');

const processTooltipData = (rawTooltipData, localeCode) => {
  try {
    const processedTermsForTooltip = rawTooltipData.termsForTooltip.map(
      rawTerm => {
        let definitionLink = null;

        if (
          rawTerm.linkType === 'Internal' &&
          rawTerm.internalLink &&
          rawTerm.internalLink.enabled
        ) {
          if (rawTerm.internalLink.internal.type === 'ContentfulResource') {
            definitionLink = rawTerm.internalLink.url;
          } else {
            const entryData = {
              ...rawTerm.internalLink,
              contentType: rawTerm.internalLink.internal.type,
            };
            definitionLink = generateEntryUrl(localeCode, entryData);
          }
        }

        if (rawTerm.linkType === 'External' && rawTerm.externalLink) {
          definitionLink = rawTerm.externalLink;
        }

        const { label, definition, definitionImage } = rawTerm;

        return {
          label,
          definition,
          definitionImage,
          definitionLink,
        };
      }
    );

    const { shouldDisplayTextTooltips, usedTooltipKeywords } = rawTooltipData;

    return {
      shouldDisplayTextTooltips,
      usedTooltipKeywords,
      termsForTooltip: processedTermsForTooltip,
    };
  } catch (error) {
    console.error('Error processing rawTooltipData', error);
    return undefined;
  }
};

module.exports = { processTooltipData };
